// removed by extract-text-webpack-plugin
module.exports = {"wrap":"wrap__1biTz","beginArrow":"beginArrow__1DwO-","shortArrow":"shortArrow__1Nv7a","endArrow":"endArrow__2sss-","title":"title__TFCKp","standfirst":"standfirst__2H8iz","descContainer":"descContainer__2n-jR","descWrapper":"descWrapper__3fGGc","descName":"descName__2n-cH","descNoun":"descNoun__10zPF","descriptionCopyContainer":"descriptionCopyContainer__2Zjd6","descriptionCopy":"descriptionCopy__3K9jl","introFact":"introFact__2tf3J"};


//////////////////
// WEBPACK FOOTER
// ./components/Intro/style.css
// module id = l8Hw
// module chunks = 0